import * as z from "zod";

export const reactivateOms = {
  name: "reactivateOms" as const,
  input: z.null(),
  output: z.null(),
};
